import React from "react";
import {Form, InputNumber} from "antd";
import {MAX_VALUE_RULE_NAME} from "@reside/forms/dist/validator/validators/maxValueValidator";

import {
  useFocusedNode,
  useSetFocusedNodePropertyValue,
} from "../../model/editor";
import {getRuleValue, isCurrencyNode, updateRules} from "../../utils";
import {FormControlSourceNode} from "../../model/schemaTypes";

export const getMaxValueRuleValue = getRuleValue(MAX_VALUE_RULE_NAME, parseInt);

export const getInitialMaxValueFormValue = (node: FormControlSourceNode) => {
  try {
    return {
      [MAX_VALUE_RULE_NAME]: getMaxValueRuleValue(node.rules),
    };
  } catch {
    return {};
  }
};

export const MaxValueAttribute = () => {
  const node = useFocusedNode();
  const setValidationRules = useSetFocusedNodePropertyValue("rules");

  if (!node) {
    return null;
  }

  return isCurrencyNode(node) ? (
    <Form.Item
      name={MAX_VALUE_RULE_NAME}
      label="Max value"
      rules={[{type: "number", min: 0}]}
    >
      <InputNumber
        min={0}
        onChange={value =>
          setValidationRules(
            updateRules(
              [...(node.rules ?? [])],
              `${value ?? ""}`,
              MAX_VALUE_RULE_NAME,
            ),
          )
        }
      />
    </Form.Item>
  ) : (
    <>
      Attribute "${MAX_VALUE_RULE_NAME}" can be used only with FORM_CONTROL
      CURRENCY type
    </>
  );
};
